export default "__VITE_ASSET__Cg8uQ_7q__"